import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
} from '@mui/material';
import { useRef } from 'react';
import useTheme from '@mui/material/styles/useTheme';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import { useParams } from 'react-router-dom';
import { IViewExpense } from '../types/expenseTypes';
import { TableNotFound } from 'src/Utils/TableLoader';
import PrintExpense from './PrintExpense';
import { SimCardDownload } from '@mui/icons-material';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from 'src/components/CommonDetailItem/CommonDetailItem';

const labelWidth = { xs: '130px', sm: '150px', md: '165px' };

const ViewExpense = () => {
  const { id } = useParams();
  const { response, loading } = GetDataApi<IViewExpense>(
    `/api/atab/expense/${id}?CompanyProfileId=1`
  );
  const theme = useTheme();
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <Box ml={3}>
      {response && (
        <Card
          className='invoice_print_form'
          sx={{ maxWidth: '1200px', margin: '0 auto' }}
        >
          <CardHeader
            title={`Expense Details`}
            action={
              <Tooltip title='Print Expense'>
                <IconButton onClick={handlePrint}>
                  <SimCardDownload
                    sx={{
                      cursor: 'pointer',
                      color: theme.colors.primary.main,
                    }}
                  />
                </IconButton>
              </Tooltip>
            }
          />
          <CardContent>
            <>
              <Box sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <CommonDetailItem
                    label='Expense Date'
                    value={formatDate(response?.expense_date, 'DD-MMM-YYYY')}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Expense No'
                    value={formatValue(response?.expense_no)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Account name'
                    value={formatValue(response?.account_name)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Payment Method'
                    value={formatValue(response?.method)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Amount'
                    value={
                      response?.amount
                        ? `${Number(response.amount).toLocaleString()} BDT`
                        : 'N/A'
                    }
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Bank name'
                    value={formatValue(response?.bank_name)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Cheque No'
                    value={formatValue(response?.cheque_no)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Cheque Date'
                    value={formatDate(response?.cheque_date, 'DD-MMM-YYYY')}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={6}
                    md={4}
                  />
                  <CommonDetailItem
                    label='Remark'
                    value={formatValue(response?.note)}
                    labelWidth={labelWidth}
                    xs={12}
                    sm={12}
                    md={12}
                  />
                </Grid>

                <>
                  <Typography
                    sx={{ textDecoration: 'underline' }}
                    mt={8}
                    mb={3}
                    color='text.'
                    align='center'
                    variant='h4'
                  >
                    Expense Items
                  </Typography>

                  <TableContainer>
                    <Table>
                      <TableHead
                        sx={{
                          backgroundColor: theme.colors.primary.main,
                        }}
                      >
                        <TableRow>
                          <TableCell
                            sx={{ color: theme.colors.alpha.white[100] }}
                          >
                            SL
                          </TableCell>

                          <TableCell
                            sx={{ color: theme.colors.alpha.white[100] }}
                            align='center'
                          >
                            Item name
                          </TableCell>

                          <TableCell
                            sx={{ color: theme.colors.alpha.white[100] }}
                            align='center'
                          >
                            Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {response?.items?.length ? (
                          <>
                            {response?.items?.map((details, index) => (
                              <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell align='center'>
                                  {details?.name}
                                </TableCell>
                                <TableCell align='center'>
                                  {details?.amount}
                                </TableCell>
                              </TableRow>
                            ))}
                          </>
                        ) : (
                          <TableNotFound />
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              </Box>
            </>
          </CardContent>
        </Card>
      )}
      <div style={{ display: 'none' }}>
        <PrintExpense response={response} componentRef={componentRef} />
      </div>
    </Box>
  );
};

export default ViewExpense;
